// extracted by mini-css-extract-plugin
module.exports = {"buttonsFooter":"AddBoxUnits_buttonsFooter__3H2fZ"};